import { styled } from '../jss-style';
import breadcrumbStyle from './breadcrumb';

const useBreadcrumbStyle = styled(breadcrumbStyle, 'breadcrumb');
export { breadcrumbStyle, useBreadcrumbStyle };
export default useBreadcrumbStyle;
